<div
  class="alert alert-warning"
  *ngIf="
    registrationApprovalProps &&
    !registrationApprovalProps.hasApprovalForRegistering
  "
>
  <ng-container
    *ngTemplateOutlet="
      template ? template : defaultTemplate;
      context: { $implicit: registrationApprovalProps }
    "
  >
  </ng-container>

  <ng-template #defaultTemplate let-item>
    فراگیر گرامی!
    <br />
    مجوز ثبت‌نام شما در کارگاه‌های آموزشی افرا صادر نشده است. برای دریافت مجوز
    ثبت‌نام با مدیرعامل موسسه نیکوکاری خود ({{ item.charityTitle }}) سرکار خانم
    / جناب آقای
    <strong>{{ item.ceoFullName }}</strong>
    تماس بگیرید.
  </ng-template>
</div>
